import { Component, Input } from '@angular/core';
import { User } from '../../core/state/users/models';

@Component({
    selector: 'black-user-info-card',
    templateUrl: './user-info-card.component.html',
    styleUrl: './user-info-card.component.css',
    standalone: false
})
export class UserInfoCardComponent {
  @Input()
  user: User | null = null;

  getUserName() {
    return (
      this.user?.profile.personal.firstName +
      ' ' +
      this.user?.profile.personal.lastName
    );
  }
}
